
export const verifyCodeRecoverPasswordMutation = `
  mutation VerifyCodeRecoverPasswordMutation($email: String!, $code: String!){
    VerifyCodeEmailForgotPassword(code: $code, email: $email){
      success
    }
  }
`;
